import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';
import { useFormikContext } from 'formik';

import { selectIsUserLogged } from '@selectors/auth';

import { DELIVERY_OPTIONS } from '@common/constants/giftCards';
import { AddressSection, SelectionControl } from '@common/components/forms';

import { AddressForInvoiceCheckboxWrapper } from './Adresses.styled';

const Addresses = ({ invoiceAddressTitle }) => {
  const { t } = useTranslation();
  const isUserLogged = useSelector(selectIsUserLogged);
  const {
    values: { address: values, directDelivery },
    handleBlur,
    handleChange,
  } = useFormikContext();

  const isDeliveryToMyHome = directDelivery === DELIVERY_OPTIONS.TO_MY_HOME;

  return (
    <React.Fragment>
      <AddressSection
        fieldPath="address.shippingAddress"
        showEmailInput={isDeliveryToMyHome && !isUserLogged}
      />

      {isDeliveryToMyHome && (
        <AddressForInvoiceCheckboxWrapper>
          <SelectionControl
            onBlur={handleBlur}
            onChange={handleChange}
            disabled={false}
            spacingTop={['equal', 3]}
            spacingBottom={['equal', 3]}
            checked={values.isSameAddressForInvoice}
            name="address.isSameAddressForInvoice"
            variant="body2"
            label={t(
              'global.form.sameAddressForInvoice.label',
              'Gleiche Adresse für die Rechnung verwenden',
            )}
          />
        </AddressForInvoiceCheckboxWrapper>
      )}

      {(!values.isSameAddressForInvoice || !isDeliveryToMyHome) && (
        <Fragment>
          {invoiceAddressTitle}

          <AddressSection
            fieldPath="address.invoiceAddress"
            showEmailInput={!isDeliveryToMyHome && !isUserLogged}
          />
        </Fragment>
      )}
    </React.Fragment>
  );
};

Addresses.propTypes = {
  invoiceAddressTitle: PropTypes.node,
};

Addresses.defaultProps = {
  invoiceAddressTitle: null,
};

export default Addresses;
